<template>
<div class="content-page">
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="page-title-box">
                    <h4 class="page-title">고시원 지점 관리
                        &nbsp;<i class="mdi mdi-information-outline font-20 align-middle list-inline-item text-primary" style="margin-top:-0.22rem;" data-bs-toggle="tooltip" data-bs-placement="right" data-bs-html="true" :data-bs-title="kosirockInfoMsg">
                        </i>
                    </h4>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-sm-4">
                    <router-link to="/kosiwon/register" class="btn btn-primary rounded-pill mb-3">
                        <i class="mdi mdi-plus"></i> 고시원 등록
                    </router-link>
                </div>
                <div class="col-sm-8" v-if="kosiwonList.length > 0">
                    <div class="text-sm-end">
                        <!-- <div class="btn-group mb-3">
                            <button type="button" class="btn btn-primary">All</button>
                        </div>
                        <div class="btn-group mb-3 ms-1">
                            <button type="button" class="btn btn-light">광고 중</button>
                            <button type="button" class="btn btn-light">광고 종료</button>
                        </div> -->
                        <div class="btn-group mb-3 ms-2 d-sm-inline-block">
                            <button type="button" class="btn" :class="gridClass" @click="changeView(true)">
                                <i class="mdi mdi-view-grid-outline"></i>
                            </button>
                        </div>
                        <div class="btn-group mb-3 d-sm-inline-block">
                            <button type="button" class="btn" :class="listClass" @click="changeView(false)">
                                <i class="mdi mdi-format-list-checkbox"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Init Empty Page -->
            <div class="row" v-if="loading"></div>

            <!-- kosiwonList.lengt > 0 || else -->
            <template v-else>
                <div class="row" v-if="kosiwonList.length > 0">
                    <!-- GRID VIEW -->
                    <template v-if="IS_GRID_VIEW">
                        <div class="col-md-4 col-xxl-3" v-for="(kosiwon, idx) in kosiwonList" :key="`kosiwon_${idx}`">
                            <div class="card d-block">
                                <div class="img-wrapper">
                                    <img class="card-img-top custom-img" :src="kosiwon.thumbnail_url || nonImage" alt="Kosiwon Thumbnail Image">
                                    <div class="card-img-overlay">
                                        <div class="badge p-1 me-1" :class="computedKosiwonActiveColor(kosiwon)" v-html="safeHTML(computedKosiwonActive(kosiwon))"></div>
                                        <div class="badge p-1" :class="computedKosiwonStatusColor(kosiwon)" v-if="kosiwon.kosiwon_update.length > 0" v-html="safeHTML(computedKosiwonStatus(kosiwon))"></div>
                                    </div>
                                </div>
                                <div class="card-body position-relative">
                                    <h4 class="card-title">
                                        {{ computedKosiwonName(kosiwon) }}
                                    </h4>
                                    <ul class="list-group list-group-flush mb-1">
                                        <li class="list-group-item list-group-item-action">
                                            <span class="fw-bold"> {{ kosiwon.intro }} </span>
                                        </li>
                                        <li class="list-group-item list-group-item-action">
                                            <span class="fw-bold">가격</span> : {{ computedKosiwonPrice(kosiwon) }}
                                        </li>
                                        <li class="list-group-item list-group-item-action">
                                            <span class="fw-bold">보증금</span> : {{ computedKosiwonDeposit(kosiwon) }}
                                        </li>
                                        <li class="list-group-item list-group-item-action">
                                            <span class="fw-bold">주소</span> : {{ kosiwon.address_brief }}
                                        </li>
                                        <li class="list-group-item list-group-item-action" v-if="kosiwon.traffics_subway.length > 0">
                                            <span class="fw-bold">지하철</span> :
                                            <span v-for="(subway, subway_idx) in kosiwon.traffics_subway" :key="`subway_idx_${subway_idx}`">
                                                <span class="badge rounded-pill" v-for="(station, station_idx) in subway.station_number.split(',')" :key="`station_idx_${station_idx}`" style="margin-top:-3px; margin-right: 2px;" :style="{'background-color' : getSubwayColor(station)}">
                                                    {{ station }}
                                                </span>
                                                <span class="me-1">
                                                    {{ subway.intro }}
                                                </span>
                                            </span>
                                        </li>
                                        <li class="list-group-item list-group-item-action">
                                            <span class="fw-bold">등록일</span> : {{ DATE_FORMAT(kosiwon.created) }}
                                        </li>
                                        <li class="list-group-item list-group-item-action">
                                            <div class="d-flex">
                                                <button type="button" class="btn btn-outline-info w-50 me-1" @click="editKosiwon(kosiwon)">
                                                    <i class="mdi mdi-home-edit-outline"></i> 정보 수정
                                                </button>
                                                <button type="button" class="btn btn-outline-primary w-50" @click="openKosirock(kosiwon)">
                                                    <i class="mdi mdi-web"></i> 고시락에서 보기
                                                </button>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="d-flex align-items-center mt-4">
                                        <div class="text-end ms-auto multi-user">
                                            <h5 class="font-13 text-muted my-0">
                                                <i class="mdi mdi-clock-outline"></i> Last Updated {{GET_TIME_AGO(kosiwon.updated)}}
                                            </h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <!-- LIST VIEW -->
                    <div class="table-responsive" v-else>
                        <table class="table table-centered table-nowrap text-center mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th>대표 사진</th>
                                    <th>고시원명</th>
                                    <th>게시 여부</th>
                                    <th>요청 상태</th>
                                    <th>가격</th>
                                    <th>보증금</th>
                                    <th>주소</th>
                                    <th>지하철</th>
                                    <th>수정 / 고시락</th>
                                    <th>등록일</th>
                                    <th>수정일</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(kosiwon, idx) in kosiwonList" :key="`kosiwon_${idx}`" @click="editKosiwon(kosiwon)">
                                    <td class="text-center">
                                        <img :src="kosiwon.thumbnail_url || nonImage" alt="Kosiwon Thumbnail Image" class="rounded me-3" height="48" />
                                    </td>
                                    <td>
                                        {{ computedKosiwonName(kosiwon) }}
                                    </td>
                                    <td>
                                        <div class="badge p-1" :class="computedKosiwonActiveColor(kosiwon)" v-html="safeHTML(computedKosiwonActive(kosiwon))"></div>
                                    </td>
                                    <td>
                                        <div class="badge p-1" :class="computedKosiwonStatusColor(kosiwon)" v-if="kosiwon.kosiwon_update.length > 0" v-html="safeHTML(computedKosiwonStatus(kosiwon))"></div>
                                    </td>
                                    <td>
                                        {{ computedKosiwonPrice(kosiwon) }}
                                    </td>
                                    <td>
                                        {{ computedKosiwonDeposit(kosiwon) }}
                                    </td>
                                    <td>
                                        {{ kosiwon.address_brief }}
                                    </td>
                                    <td>
                                        <span v-for="(subway, subway_idx) in kosiwon.traffics_subway" :key="`subway_idx_${subway_idx}`">
                                            <span class="badge rounded-pill" v-for="(station, station_idx) in subway.station_number.split(',')" :key="`station_idx_${station_idx}`" style="margin-top:-3px; margin-right: 2px;" :style="{'background-color' : getSubwayColor(station)}">
                                                {{ station }}
                                            </span>
                                            <span class="me-1">
                                                {{ subway.intro }}
                                            </span>
                                        </span>
                                    </td>
                                    <td>
                                        <button type="button" class="btn btn-sm btn btn-outline-info font-13 me-1">
                                            <i class="mdi mdi-home-edit-outline"></i> 정보 수정
                                        </button>
                                        <button type="button" class="btn btn-sm btn-outline-primary font-13" @click.stop="openKosirock(kosiwon)">
                                            <i class="mdi mdi-web"></i> 고시락에서 보기
                                        </button>
                                    </td>
                                    <td>
                                        {{ DATE_FORMAT(kosiwon.created) }}
                                    </td>
                                    <td>
                                        <i class="mdi mdi-clock-outline"></i> Last Updated {{ GET_TIME_AGO(kosiwon.updated) }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row justify-content-center" style="margin-top: 5rem !important" v-else>
                    <div class="col-xl-10">
                        <div class="text-center">
                            <img src="assets/images/svg/features-1.svg" height="140" alt="File not found Image">
                            <h3 class="mt-4">등록된 고시원이 존재하지 않습니다.</h3>
                            <p class="text-muted mt-3">고시원을 등록하여 고시락에 노출시켜보세요!<br />입주 관리 서비스와 다양한 알림 서비스도 받아보실 수 있습니다.</p>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import {
    DATE_FORMAT,
    GET_TIME_AGO
} from "@/config/date.js";
import common from "@/mixins/common.js";

export default {
    data() {
        return {
            DATE_FORMAT: DATE_FORMAT,
            GET_TIME_AGO: GET_TIME_AGO,

            IS_GRID_VIEW: true,
            loading: true,

            kosirockInfoMsg: "고시원 정보 등록/수정 요청 시,<br/>운영자에 승인이 완료되면<br/>고시락에 즉시 반영됩니다.",
            nonImage: "https://s3.ap-northeast-2.amazonaws.com/kosirock.kosiwons.image/temp/f3b30af95fa6866634bdad2e2c85e71dbaf236193902f5e2b07486740f176d61.png",

            kosiwonList: [],

            kosiwonStatus: {
                approved: {
                    text: "수정 요청 반영",
                    color: "text-bg-info",
                    icon: "mdi-check-bold"
                },
                pending: {
                    text: "수정 요청",
                    color: "text-bg-warning",
                    icon: "mdi-timer-sand"
                },
                rejected: {
                    text: "수정 요청 거절",
                    color: "text-bg-danger",
                    icon: "mdi-cancel"
                },
                canceled: {
                    text: "수정 요청 취소",
                    color: "text-bg-secondary",
                    icon: "mdi-close"
                }
            }
        };
    },
    mixins: [
        common
    ],
    async mounted() {
        try {
            const res = await this.axios.get("/kosiwon?isSubway=true&isUpdate=true");
            this.kosiwonList = res.data.result;

            this.$nextTick(() => {
                this.$store.commit("INIT_TOOLTIP");
            });
        } catch (error) {
            console.log(error);
        } finally {
            this.loading = false;
        }
    },
    computed: {
        gridClass() {
            return this.IS_GRID_VIEW ? "btn-secondary" : "text-muted";
        },
        listClass() {
            return this.IS_GRID_VIEW ? "text-muted" : "btn-secondary";
        }
    },
    methods: {
        changeView(flag) {
            if (this.IS_GRID_VIEW !== flag) {
                this.IS_GRID_VIEW = !this.IS_GRID_VIEW;
            }
        },
        computedKosiwonStatus(kosiwon) {
            return this.safeHTML(`<i class="mdi ${this.kosiwonStatus[kosiwon.kosiwon_update[0].status].icon || ""}"></i> ${this.kosiwonStatus[kosiwon.kosiwon_update[0].status].text || "오류 발생"}`);
        },
        computedKosiwonStatusColor(kosiwon) {
            return this.kosiwonStatus[kosiwon.kosiwon_update[0].status].color || "text-bg-secondary";
        },
        computedKosiwonActive(kosiwon) {
            return this.safeHTML(kosiwon.is_public ? `<i class="mdi mdi-post"></i> 게시 중` : `<i class="mdi mdi-timer-sand"></i> 심사 중`);
        },
        computedKosiwonActiveColor(kosiwon) {
            return kosiwon.is_public ? "text-bg-success" : "text-bg-warning";
        },
        computedKosiwonName(kosiwon) {
            return `${kosiwon.name} ${kosiwon.branch}`;
        },
        computedKosiwonPrice(kosiwon) {
            return `${kosiwon.price_min} ~ ${kosiwon.price_max}만원`;
        },
        computedKosiwonDeposit(kosiwon) {
            return kosiwon.deposit ? `${kosiwon.deposit}만원` : "없음";
        },
        editKosiwon(kosiwon) {
            this.$router.push({
                path: `/kosiwon/register/${kosiwon.pk}`
            });
        },
        openKosirock(kosiwon) {
            if (!kosiwon.is_public) {
                alert("아직 승인되지 않은 고시원입니다.\n영업일 기준 1~3일 소요됩니다.");
                return;
            }

            const url = `https://kosirock.com/detail/${kosiwon.pk}`;
            window.open(url, "_blank");
        }
    }
}
</script>

<style>
.img-wrapper {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    /* 16:9 비율 */
}

.custom-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
